import React from 'react';

import { default as CheckMark } from '@assets/icons/vwp/CheckMark.svg?react';
import { default as Wallet } from '@assets/icons/vwp/Wallet.svg?react';
import { default as TimeMoney } from '@assets/icons/vwp/TimeMoney.svg?react';

import scss from './SalePoints.module.scss';

const SalePoints = () => {
    return (
        <>
            <div className={scss.fadingBorder}></div>
            <div className={scss.container}>
                <div className={scss.salePoint}>
                    <div>
                        <TimeMoney />
                    </div>
                    <div>
                        <div className={scss.heading}>24 months</div>
                        <div className={scss.subHeading}>Interest Free</div>
                        <div>Lock in your date now, pay later in flexible instalments</div>
                    </div>
                </div>
                <div className={scss.salePoint}>
                    <div>
                        <Wallet />
                    </div>
                    <div>
                        <div className={scss.heading}>savings</div>
                        <div className={scss.subHeading}>That really add up!</div>
                        <div>Earn WedPoints and redeem them for big supplier discounts</div>
                    </div>
                </div>
                <div className={scss.salePoint}>
                    <div>
                        <CheckMark />
                    </div>
                    <div>
                        <div className={scss.heading}>refundable</div>
                        <div className={scss.subHeading}>$99 deposit</div>
                        <div>Change your mind within 48 hours and get a full refund</div>
                    </div>
                </div>
            </div>
            <div className={scss.fadingBorder}></div>
        </>
    );
};

export default SalePoints;